/* content file: replace all html between <> </> with actual content */

export const AwardGesundheitsstadt = () => {
  return (
  <>
    <p>
      Der Award zeichnet Projekte aus, die Digitalisierung im Gesundheitswesen nicht nur technisch, sondern ganzheitlich denken: mit klaren Verantwortlichkeiten, eingebundenen Teams und messbaren Verbesserungen im Versorgungsalltag. Der diesjährige Schwerpunkt: souveräner, sicherer und vertraulicher Umgang mit digitalen Technologien und sensiblen Gesundheitsdaten.</p>
  </>    
  )
}